/* eslint-disable @typescript-eslint/no-explicit-any */
import { useQuery } from '@tanstack/react-query';

import { checkReportSavingStatus } from 'apis/hcp/processeddata.api';
import { queryClient } from 'configs/query';

const useCheckStatus = (
  hash: string,
  recordingId: string,
  testId: string,
  resetHash: () => void
) => {
  const { isFetching, data } = useQuery({
    queryKey: ['pollData', hash],
    queryFn: ({ signal }) => checkReportSavingStatus(hash, signal),
    refetchOnWindowFocus: false,
    enabled: !!hash,
    refetchIntervalInBackground: true,
    refetchInterval: (query: any) => {
      if (query?.state?.data?.data?.processed) {
        sessionStorage.removeItem(`hash-${recordingId}`);
        resetHash();
        queryClient.removeQueries({ queryKey: ['processeddata', recordingId] });
        Promise.all([
          queryClient.invalidateQueries({ queryKey: ['pdf-report'] }),
          queryClient.invalidateQueries({
            queryKey: ['reports', 'nightly', 'variables', recordingId],
          }),
          queryClient.invalidateQueries({ queryKey: ['reports', 'summary', 'variables', testId] }),
        ]);
        return false;
      }
      return 4000;
    },
  });

  return { isFetching, data };
};

export default useCheckStatus;
